exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._2M7-zJRiy7K8D7mqrxN6Rt span{margin-right:12px}._2M7-zJRiy7K8D7mqrxN6Rt span:last-child{margin-right:0}\n", ""]);

// Exports
exports.locals = {
	"goalDetail": "_2M7-zJRiy7K8D7mqrxN6Rt"
};